<template>
  <div class="age">
    {{ $t("age") }}

    <select v-model="age"
            dir="rtl"
            class="age-select"
            @change="changeAge(age)">
      <option v-for="option in options"
              v-bind:value="option"
              :key="option">
        {{ option }}
      </option>
    </select>
  </div>
</template>

<script>
  import analytics from '@/services/analytics.js'

  export default {
    props: {
      childAge: {
        type: [Number, String],
        required: true
      }
    },

    data() {
      return {
        age: null,
        options: _.range(1, 22)
      }
    },

    created() {
      this.age = this.childAge
    },

    methods: {
      changeAge(age) {
        analytics.sendEvent('Pk_Age_EditCh')
        this.$emit('changeAge', age)
      }
    },

    watch: {
      childAge(age) {
        this.age = age
      }
    }
  }
</script>

<style lang="scss" scoped>
  .age {
    display: flex;
    justify-content: space-between;

    padding: 18px 0 18px 0;
    margin-bottom: 14px;

    .age-select {
      background: transparent;
      width: 20px;
      padding-right: 3px;
      text-align: center;

      border: none;
      outline: none;
      appearance: none;
      cursor: pointer;
    }
  }
</style>
